import React from "react";

type Props = {};

const Relief89Hint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<p className="leading-para text-greyDark mb-4">
				Tax is calculated on your total income earned during the year. But, if your total salary
				includes any past dues (i.e. arrears) paid in the current year, or you have received family
				pension in arrears, you are allowed some tax relief under section 89(1) read along with Rule
				21A. In simple words you are saved from paying more tax because of delay in payment to you.
			</p>
			<p className="leading-para text-greyDark">
				Please note that in order to claim this relief you need to submit Form 10E to the income Tax
				Department first.
			</p>
		</>
	);
};

export default Relief89Hint;
